import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {AdsBannersComponent} from "../ads-banners/ads-banners.component";

@NgModule({
  declarations: [AdsBannersComponent],
  imports: [CommonModule],
  exports: [AdsBannersComponent]
})
export class AdsBannersModule{ }
